<template>
  <div
    class="amap-location"
    :class="{ 'hidden-geo': hiddenGeo }"
    @click="handleClick"
  >
    <div
      :id="`amap-location-${id}`"
      class="amap-content"
      :style="{ height }"
    ></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "MapLocation",

  props: {
    value: {
      type: Array,
      default: () => [],
    },
    zoom: {
      type: Number,
      default: 15,
    },
    hiddenGeo: {
      type: Boolean,
      default: true,
    },
    getCurrentPosition: {
      type: Boolean,
      default: true,
    },
    modify: Boolean,
    onLoaded: Function,
    onDestroy: Function,
    height: {
      type: [String, Number],
      default: "100vh",
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      id: String(Math.random()).slice(3, 8),
      position: null,
      AMap: null,
      Marker: null,
      isDrag: true,
    };
  },

  computed: {
    ...mapGetters(["webConfig"]),
  },

  watch: {
    value(val) {
      if (!this.AMap) {
        return;
      }
      if (val && val.length === 2 && !this.modify) {
        this.resetMarker(val);
      }
    },
  },

  async mounted() {
    const pos = await this.getPosition();
    console.log("pos ===>", pos);
    this.position = pos;
    this.initHwMap();
  },

  beforeDestroy() {
    if (typeof this.onDestroy === "function") {
      this.onDestroy();
    }
    if (this.AMap) {
      this.AMap = null;
      this.Marker = null;
      this.position = null;
    }
  },
  methods: {
    getPosition() {
      return new Promise((resolve, reject) => {
        if (this.value.length === 2) {
          return resolve({
            lng: this.value[0],
            lat: this.value[1],
          });
        } else {
          const res = axios
            .post(
              `https://siteapi.cloud.huawei.com/mapApi/v1/siteService/searchByText?key=${encodeURIComponent(
                this.webConfig.world_map_key
              )}`,
              {
                query: this.webConfig.area,
                cityId: this.webConfig.adcode,
                cityLimit: true,
              }
            )
            .then((res) => {
              if (res.status === 200) {
                return resolve({
                  lng: res.data.sites[0].location.lng,
                  lat: res.data.sites[0].location.lat,
                });
              } else {
                return reject();
              }
            })
            .catch((err) => {
              return reject();
            });
        }
      });
    },

    async initHwMap() {
      this.AMap = new window.HWMapJsSDK.HWMap(
        document.getElementById(`amap-location-${this.id}`),
        {
          center: this.position,
          zoom: this.zoom,
          language: "CHI",
          sourceType: "vector",
          zoomControl: false,
        }
      );
      this.setHwMarker(this.position);

      if (this.modify) {
        this.AMap.on("pointerdrag", () => {
          this.isDrag = true;
          this.$emit("dragstart");
        });

        this.AMap.on("moveend", () => {
          if (this.readOnly) return;
          const center = this.AMap.getCenter();
          this.setHwMarker(center);
          this.$emit("moveend");
          this.$emit("input", [center.lng, center.lat]);
        });
      }
      this.$emit("on-init-success");
    },

    setHwMarker(position) {
      if (!this.Marker) {
        this.Marker = new window.HWMapJsSDK.HWMarker({
          map: this.AMap,
          position,
          draggable: true,
          icon: {
            url: "https://webapi.amap.com/theme/v1.3/markers/b/mark_bs.png",
            scale: 0.5,
          },
        });
        if (!this.readOnly) {
          this.Marker.addListener("position_changed", this.positionChanged);
        }
      } else {
        this.Marker.setPosition(position);
      }
    },

    positionChanged() {
      if (!this.isDrag) return;
      const url =
        "https://siteapi.cloud.huawei.com/mapApi/v1/siteService/reverseGeocode?key=" +
        encodeURIComponent(this.webConfig.world_map_key);
      const data = {
        location: this.Marker.getPosition(),
      };
      axios({
        method: "post",
        url,
        data,
      })
        .then((res) => {
          if (
            res.status === 200 &&
            res.data.returnCode === "0" &&
            res.data.sites &&
            res.data.sites.length > 0
          ) {
            this.$emit("detail", res.data.sites);
          }
        })
        .catch((e) => {
          console.log(e);
        });
      this.isDrag = false;
    },

    resetMarker(locationParams) {
      if (locationParams) {
        this.AMap.setCenter({ lng: locationParams[0], lat: locationParams[1] });
        this.AMap.setZoom(this.zoom);
        this.setHwMarker({ lng: locationParams[0], lat: locationParams[1] });
      }
    },

    getLocation() {
      const options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      };
      return new Promise((resolve, reject) => {
        return navigator.geolocation.getCurrentPosition(
          resolve,
          reject,
          options
        );
      });
    },

    handleClick() {
      this.$emit("click");
    },
  },
};
</script>

<style scoped lang="less">
.amap-content {
  height: 100vh;
  width: 100%;
}

.amap-location {
  position: relative;
  overflow-y: auto;

  &.hidden-geo .amap-geolocation-con {
    display: none !important;
  }

  #amap-location {
    width: inherit;
    height: 100%;
  }

  .amap-logo,
  .amap-copyright {
    display: none !important;
  }
}

.amap-location.hidden-geo :deep(.amap-geolocation-con) {
  display: none !important;
}
</style>
